module.exports = __webpack_public_path__ + "img/bg.ea9a7867.png";